import { ViewColumnOutlined } from '@mui/icons-material';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { ComponentLoader } from '../../../../common/components/ComponentLoader';
import { ColumnPlaceholderSkeleton } from './skeletons/ColumnPlaceholderSkeleton';

type Props = {
  title: string;
  subtitle: string;
  loading: boolean;
  initialLoad: boolean;
};

export const ColumnPlaceholder = memo(({ title, subtitle, loading, initialLoad }: Props) => {
  if (initialLoad) {
    return <ColumnPlaceholderSkeleton />;
  }
  return (
    <Box className="column-placeholder" sx={{ height: 1, width: 1, '& > div': { height: 1, '& > div': { height: 1 } } }}>
      <ComponentLoader loading={loading}>
        <Card sx={{ height: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', py: 4 }}>
          <CardContent sx={{}}>
            <Stack sx={{ maxWidth: '250px', alignItems: 'center' }} spacing={1}>
              <ViewColumnOutlined />
              <Typography variant="body1">{title}</Typography>
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      </ComponentLoader>
    </Box>
  );
});
